import React, { useContext } from 'react';
import Big from 'big.js';
import IExchangeAmount from './IExchangeAmount';
import * as style from './ExchangeAmountStyle.module.scss'
import IconInput from '@appComponents/IconInput/IconInput';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import { FundsDispatchContext } from '@features/context';
import { renameMainCurrency } from '@features/utils/functions';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import QuestionMark from '@appComponents/QuestionMark/QuestionMark';

import * as elements from '@appStyles/_elements.module.scss';

const ExchangeAmount: React.FunctionComponent<IExchangeAmount> = (props) => {
  const dispatch = useContext(FundsDispatchContext);
  const displayError = props.outcomeAmount !== null;

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: 'edit',
      payload: { value: e.target.value, name: e.target.name },
    });
  };

  const onMaximumClick = () => {
    dispatch({
      type: 'setMaximumAmount',
    });
  };

  return (
    <div className={style.exchangeAmount}>
      <IconInput
        icon={renameMainCurrency(props.currency) || '---'}
        onChange={onInputChange}
        value={props.outcomeAmount || ''}
        errorMsg={displayError ? (props.errors.outcomeAmount || '') : ''}
        name="outcomeAmount"
        placeholder="Put Amount here"
        type="number"
        label={`Amount of ${renameMainCurrency(props.currency).toUpperCase() || 'currency'} to ${props.type}:`}
        autoComplete="off"
        data-cy="exchange-input"
        onWheel={event => event.currentTarget.blur()}
      />
      <button className={elements.maximumBtn} onClick={onMaximumClick}>
        Maximum Amount
      </button>
      <div className={style.transactionFee}>
        <p data-cy="transaction-fee" className={style.tradingFeeWrapper}>
          <div className={style.tradingFee}>
            <ToolTip
              text="0.5% trading fees, see Fees page"
            >
              <QuestionMark />
            </ToolTip>
            <a
              href="https://bnktothefuture.com/fees/"
              target="_blank"
              title="View fees"
              className={style.tradingFeeUrl}
            >
              <strong>Trading fees: </strong>
            </a>
          </div>
          <CurrencyElement
            value={getTransactionFee(props.outcomeAmount, props.feePercent)}
            currency={props.currency}
          />
        </p>
      </div>
    </div>
  );
};

export const getTransactionFee = (outcomeAmount: number | null, feePercent: number, resultAsNumber = false) => {
  const value = Big(outcomeAmount || 0).times(feePercent).div(100);
  if (!resultAsNumber) {
    return value;
  }

  return Number(value);
};

export default ExchangeAmount;
